// based on vc-select 7.7.5
import Select from './Select'
import Option from './Option'
import { SelectPropTypes } from './PropTypes'
import OptGroup from './OptGroup'
Select.Option = Option
Select.OptGroup = OptGroup
export { Option, OptGroup, SelectPropTypes }
export default Select



// WEBPACK FOOTER //
// ./components/vc-select/index.js